import { BaseService } from '../../../http/BaseHttpService';
import { buildNexusUrl } from '../../../../features/utils/buildNexusUrl';
import {
    EnhanceNexusPromptRequest,
    EnhanceNexusPromptResponse,
    INexusPromptEnhancerService,
} from '../interfaces/INexusPromptEnhancerService';

interface NexusEnhancePromptApiResponse {
    enhancedPrompt?: string;
    reasoning?: string | null;
}

export class NexusPromptEnhancerService extends BaseService implements INexusPromptEnhancerService {
    private readonly subscriptionKey = process.env.REACT_APP_NEXUS_APIM_SUBSCRIPTION_KEY ?? '';
    private readonly subKeyHeader = process.env.REACT_APP_NEXUS_APIM_KEY_HEADER_NAME ?? '';
    constructor(private readonly baseUrl: string) {
        super();
    }

    public async enhancePromptAsync(
        request: EnhanceNexusPromptRequest,
        accessToken: string,
    ): Promise<EnhanceNexusPromptResponse> {
        const response = await this.getResponseAsync<NexusEnhancePromptApiResponse>(
            {
                url: buildNexusUrl(this.baseUrl, 'prompt-enhancer/enhance'),
                method: 'POST',
                body: {
                    prompt: request.prompt,
                },
                headers: {
                    [this.subKeyHeader]: this.subscriptionKey,
                },
            },
            accessToken,
        );

        return {
            enhancedPrompt: response.enhancedPrompt ?? '',
        };
    }
}

export default NexusPromptEnhancerService;
